import { render } from "./HouseLayout.vue?vue&type=template&id=abb2926e"
import script from "./HouseLayout.vue?vue&type=script&lang=js"
export * from "./HouseLayout.vue?vue&type=script&lang=js"

import "./HouseLayout.vue?vue&type=style&index=0&id=abb2926e&lang=css"

import exportComponent from "C:\\Users\\Раиль\\Desktop\\Projects\\Mercury\\topaz.plugin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__